module.exports = __webpack_public_path__ + "media/images/icons/apple-podcast-b64f33535279e8424185985c85fd2984.svg";